import BrandSafery from './brand-safety';

export default BrandSafery;